// Adds listnert to klaviyo popup buttons
document.addEventListener("DOMContentLoaded", function () {
  document
    .querySelectorAll(".open-klaviyo-form-button")
    .forEach((btn) => btn.addEventListener("click", handlePopupClick));

  function handlePopupClick() {
    const formId = this.getAttribute("data-form-id");
    if (formId) {
      handleOpenPopup(formId);
    }
  }

  function handleOpenPopup(formId) {
    window._klOnsite = window._klOnsite || [];
    window._klOnsite.push(["openForm", formId]);
  }
});
